import { render } from "./user-name.vue?vue&type=template&id=10bd5b23&ts=true"
import script from "./user-name.vue?vue&type=script&lang=ts"
export * from "./user-name.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__